import { Typography } from '@mui/material';
import { AppRoutes, getUTCDate, RootState, RouteName, useAppDispatch, useAppSelector, verifyCaptcha } from 'common';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CfDialog } from '../../../../cf-ui/dialogs/Dialog/CfDialog';
import CaptchaWidget from '../common/CaptchaWidget';

const WARNING_WINDOW_MS = 10 * 60 * 1000; // 10 minutes

export const CaptchaRevalidationDialog = (): JSX.Element => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const userSite = useAppSelector((s: RootState) => s.user.userSite);

  const [open, setOpen] = useState(false);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    if (location.pathname === AppRoutes[RouteName.HumanVerification].Path) {
      setOpen(false);
      return;
    }

    if (!userSite?.RequiresCaptcha || !userSite?.RequiresCaptchaExpiresDate) return;

    const expiresAt = getUTCDate(userSite.RequiresCaptchaExpiresDate).getTime();
    const now = Date.now();
    const msUntilWarning = expiresAt - now - WARNING_WINDOW_MS;

    if (msUntilWarning <= 0) {
      setOpen(true);
      return;
    }

    timeoutRef.current = window.setTimeout(() => {
      setOpen(true);
    }, msUntilWarning);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [userSite?.RequiresCaptchaExpiresDate, location.pathname]);

  const handleVerified = async (token: string) => {
    await dispatch(verifyCaptcha(token));
    setOpen(false);
  };

  return (
    <CfDialog
      isOpen={open}
      title='Verification required'
      hasCloseButton
      hasPrimaryButton={false}
      hasSecondaryButton={false}
    >
      <Typography sx={{ mb: 2 }}>To continue using the application, please re-verify that you are human.</Typography>

      <CaptchaWidget onVerified={handleVerified} />
    </CfDialog>
  );
};
